import { Reducer, Effect, Subscription, history } from 'umi';
import { WSS_URL } from '@/constant';
import { MessageInfo } from '@/pages/typings';
import { getMessageTopic, getTopic } from '@/services/inquiry';
import { batchDeleteMessage, batchReadMessage, deleteMessage, getMessageList, readMessage } from '@/services/message';
import { message, notification, Typography } from 'antd';
// @ts-ignore
import ding from '@/assets/audios/new_task_remind.wav';
import { createElement } from 'react';

export interface MessageCenterState {
  messageList: MessageInfo[];
  currentMessage?: MessageInfo;
};

let messageCenterWssTimer: NodeJS.Timeout | null = null;
let messageCenterWssRunning: boolean = false;
export interface MessageCenterType {
  namespace: 'messageCenter',
  state: MessageCenterState,
  reducers: {
    [key: string]: Reducer;
  },
  effects: {
    [key: string]: Effect;
  },
  subscriptions: {
    [key: string]: Subscription;
  }
};

const audio = new Audio(ding);

const playAudio = () => {
  // audio.volume = 0.4;
  audio.play();
}

const MessageCenterModel: MessageCenterType = {
  namespace: 'messageCenter',
  state: {
    messageList: [],
    currentMessage: undefined
  },
  reducers: {
    setMessageList (state, { payload }) {
      state.messageList = payload;
    },
    setCurrentMessage (state, { payload }) {
      state.currentMessage = payload;
    }
  },
  effects: {
    *onMessageListClick ({ payload }, { call, put, select }) {
      if (!payload.readFlag) {
        yield put({ type: 'readMessage', payload })
      }
      // 如果来源是创建客户，则跳转到客户详情
      if (payload.subType === 'new_customer') {
        window.open('/Customer/CustomerDetail?customerId=' + payload.relateData.id, '_blank');
        return;
      }
      // 如果是任务相关，则显示任务详情
      yield put({ type: 'setCurrentMessage', payload });
    },

    *readMessage ({ payload }, { call, put, select }) {
      try {
        const { code } = yield call(readMessage, { id: payload.id });
        if (code === 200) {
          const messageList: MessageInfo[] = yield select((state: any) => state.messageCenter.messageList);
          const tempMessageList = [...messageList];
          const targetIndex = messageList.findIndex(item => item.id === payload.id);
          if (targetIndex !== -1) {
            const targetMessage = Object.assign(
              {},
              { ...tempMessageList[targetIndex] },
              { readFlag: true }
            );
            tempMessageList[targetIndex] = targetMessage;
            yield put({ type: 'setMessageList', payload: tempMessageList });
          }
        }
      } catch (e) {
        console.log(e)
      }
    },

    *deleteMessage ({ payload }, { call, put, select }) {
      try {
        const { code } = yield call(deleteMessage, { id: payload.id });
        if (code === 200) {
          message.success('删除成功');
          const messageList: MessageInfo[] = yield select((state: any) => state.messageCenter.messageList);
          const tempMessageList = [...messageList];
          const targetIndex = messageList.findIndex(item => item.id === payload.id);
          tempMessageList.splice(targetIndex, 1);
          yield put({ type: 'setMessageList', payload: tempMessageList });

          // 如果删除的是当前消息
          const currentMessage: MessageInfo = yield select((state: any) => state.messageCenter.currentMessage);
          if (payload.id === currentMessage?.id) {
            yield put({ type: 'setCurrentMessage', payload: undefined });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    *batchDeleteReadedMessage (action, { call, put, select }) {
      try {
        const { code } = yield call(batchDeleteMessage, { readFlag: true });
        if (code === 200) {
          message.success('删除成功');
          yield put({ type: 'getMessageList' });
        }
      } catch (e) {
        console.log(e);
      }
    },

    *readAllMessage (action, { call, put, select }) {
      try {
        const { code } = yield call(batchReadMessage, { readFlag: true });
        if (code === 200) {
          message.success('操作成功');
          yield put({ type: 'getMessageList' });
        }
      } catch (e) {
        console.log(e);
      }
    },
    *messageHandler ({ payload }, { call, put, select }) {
      if (payload.biz !== 'TASK_NEW') {
        playAudio();
        notification.open({
          message: '新消息提醒',
          duration: 5,
          description: messageContent(payload.biz, payload.content?.content)
        });
        const messageList: MessageInfo[] = yield select((state: any) => state.messageCenter.messageList);
        const tempMessageList = [...messageList];
        tempMessageList.unshift(payload.content);
        yield put({ type: 'setMessageList', payload: tempMessageList });
      }
    },

    *getMessageList ({ payload }, { call, put, select }) {
      let messageList: MessageInfo[] = [];
      try {
        const { code, data: { list } } = yield call(getMessageList, { ...payload });
        if (code === 200) {
          messageList = list;
        }
      } catch (error) {
        console.log(error);
      }
      // 如果最新获取到的消息列表中，没有 currentMessage， 则将 currentMessage 删除
      const currentMessage: MessageInfo = yield select((state: any) => state.messageCenter.currentMessage);
      const findCurrentMessage = messageList.find(item => item.id === currentMessage?.id);
      if (!findCurrentMessage) {
        yield put({ type: 'setCurrentMessage', payload: undefined });
      }
      yield put({ type: 'setMessageList', payload: messageList });
    }
  },
  subscriptions: {
    setup ({ history, dispatch }) {
      let messageCenterWss: WebSocket | null = null;

      const initMessageCenterWebsocket = async () => {
        if (messageCenterWssRunning) return;
        messageCenterWssRunning = true;
        const { data: topic } = await getMessageTopic();
        messageCenterWss = new WebSocket(WSS_URL);
        messageCenterWss.onopen = () => {
          messageCenterWss?.send(topic);
        };
        messageCenterWss.onmessage = (msg) => {
          dispatch({ type: 'messageHandler', payload: JSON.parse(msg.data) });
        };
        messageCenterWss.onerror = (err) => console.log('wss error', err);
        messageCenterWss.onclose = (err) => console.log('wss close', '断开连接', console.log(err));
        // 保持 ping
        if (messageCenterWssTimer) clearInterval(messageCenterWssTimer);
        messageCenterWssTimer = setInterval(() => {
          try {
            // 判断wss 状态，如果正在连接中则无视
            // 如果断联，则重新连接
            switch (messageCenterWss?.readyState) {
              case 0:
                break;
              case 1:
                messageCenterWss?.send('ping');
                break;
              default:
                clearMessageCenterWebsocket();
                dispatch({ type: 'getMessageList' });
                initMessageCenterWebsocket();
                break;
            }
          } catch (error) {}
        }, 55 * 1000);
      };
      const clearMessageCenterWebsocket = () => {
        messageCenterWssTimer && clearInterval(messageCenterWssTimer);
        messageCenterWss = null;
        messageCenterWssRunning = false;
      };
      return history.listen(({ pathname }) => {
        if (pathname.toLowerCase() !== '/user/login') {
          dispatch({ type: 'getMessageList' });
          initMessageCenterWebsocket();
        } else {
          clearMessageCenterWebsocket();
        }
      })
    }
  }
};

export default MessageCenterModel;

function messageContent(bizCode: string, content?: string) {
  if (!content) {
    return '您有一条新消息，请在消息中心查收~'
  }
  if (bizCode === 'APPT_ITEM_SURE') {
    return createElement(Typography.Text, {}, [
      '您有一条新的预约订单提醒，点击',
      createElement(Typography.Link, {
        onClick() {
          history.push('/OrderAdministrate/OrderForm')
        }
      }, '查看详情')
    ])
  }
  return content;
}
